import { BaseModel } from "../base-model";
import { ItemStateModel } from "../base-itemstate";
import { IBaseTranslation } from "../base-translation";

export interface IPersonDocumentModel extends ItemStateModel {
  PersonId?: number;
  IsFolder?: boolean;
  GroupId?: number;
  Comments?: string;
  Filename?: string;
  DocumentTypeId?: number;
  PublishOnInternetId?: number;
  IsIncludeInMail?: boolean;
  IsConvertToPDF?: boolean;
  LanguageId?: number;
  PreviewFileName?: string;
  DocumentTypeInfo?: IBaseTranslation;
  PublishOnInternetInfo?: IBaseTranslation;
  ItemState?: number;
  FilePath?: string;
  IsGroup?: boolean;
  URL?: string;
  IconURL?: string;
	EditUrl?: string;
  EditType?: DocumentEditType;
  _expanded?: boolean;
  _level?: number;
  _selected?: boolean;
  _show?: boolean;
  parent?: PersonDocumentModel;
  children?: PersonDocumentModel[];
}
export class PersonDocumentModel extends BaseModel<IPersonDocumentModel>
  implements IPersonDocumentModel {
  get IsGroup(): boolean {
    return !(this.DocumentTypeId > 0);
  }

  Id?: number;
  PersonId: number;
  IsFolder: boolean;
  GroupId: number;
  Comments: string;
  Filename: string;
  DocumentTypeId: number;
  PublishOnInternetId: number;
  IsIncludeInMail: boolean;
  IsConvertToPDF: boolean;
  LanguageId: number;
  PreviewFileName: string;
  DocumentTypeInfo: IBaseTranslation;
  PublishOnInternetInfo: IBaseTranslation;
  FilePath: string;
  ItemState: number;
  URL: string;
  IconURL?: string;
	EditUrl?: string;
  EditType?: DocumentEditType;
  _expanded?: boolean;
  _level?: number;
  _selected?: boolean;
  _show?: boolean;
  parent?: PersonDocumentModel;
  children?: PersonDocumentModel[];
  /**
   *
   */
  constructor(option?: IPersonDocumentModel) {
    super(option);
  }
}

export class PersonDocumentUpdateModel {
  Id: number;
  Field: string;
  Value: object;
}

export class MoveGroupModel {
  fromId: number;
  toId: number;
}

export enum DocumentEditType {
  Word = 1,
  Excel = 2,
  PowerPoint = 3,
}
